import { render } from "./mvt-localhighlight.vue?vue&type=template&id=9efce5d8"
import script from "./mvt-localhighlight.js?vue&type=script&lang=js"
export * from "./mvt-localhighlight.js?vue&type=script&lang=js"

import "./mvt-localhighlight.vue?vue&type=style&index=0&id=9efce5d8&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__